import { Link } from "react-router-dom";

const Footer = () => {
  const quickLinks = [
    { label: "Home", to: "/" },
    { label: "About", to: "/about" },
    { label: "Placements", to: "/placements" },
    { label: "Contact", to: "/contact" },
  ];

  const resources = [
    { label: "Trainer Playbook", to: "/about" },
    { label: "Cohort Calendar", to: "/contact" },
    { label: "Placement FAQs", to: "/placements" },
  ];

  const socials = [
    { label: "LinkedIn", href: "https://linkedin.com" },
    { label: "Twitter", href: "https://twitter.com" },
    { label: "YouTube", href: "https://youtube.com" },
  ];

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <p className="eyebrow">Trainee Management</p>
          <h3>From orientation to offer letter, we keep every cohort on track.</h3>
          <p className="muted">
            A lightweight workspace for admins, trainers, and trainees to stay aligned on attendance,
            learning outcomes, and placements.
          </p>
          <div className="footer-badges">
            <span>Live cohorts: 12</span>
            <span>Response time: &lt; 2 hrs</span>
          </div>
        </div>

        <div className="footer-columns">
          <div className="footer-col">
            <h4>Navigate</h4>
            <ul>
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Resources</h4>
            <ul>
              {resources.map((item) => (
                <li key={item.label}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <p>Orbit Tower, 4th Floor</p>
            <p>MG Road, Bengaluru</p>
            <p>support@training.io</p>
            <p>+91 98765 43210</p>
            <p>Mon-Fri, 9:00 AM - 7:00 PM IST</p>
          </div>

          <div className="footer-col">
            <h4>Follow us</h4>
            <div className="socials">
              {socials.map((item) => (
                <a key={item.label} href={item.href} target="_blank" rel="noreferrer">
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>(c) 2026 Trainee Management System. Built for modern training teams.</p>
        <div className="footer-bottom-links">
          <span>Privacy</span>
          <span>Terms</span>
          <span>Security</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
